import { createFileRoute } from "@tanstack/react-router"
import { dashboardDateQuery, type DashboardDateSelection } from "@nova-ai/shared"
import { AppShell } from "../components/layout/app-shell"
import { MarketplaceRevenueOverview } from "../components/dashboard/marketplace-revenue-overview"
import { useMarketplaceSummaries } from "../services/use-dashboard"
import { useOfferHealthRollup } from "../services/use-offer-health"
import { useRates } from "../services/use-rates"
import { dashboardDateSearchSchema, selectionFromDashboardSearch } from "../lib/dashboard-period"

function DashboardPicker() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()
  const selection = selectionFromDashboardSearch(search)
  const summaries = useMarketplaceSummaries(selection)
  const rates = useRates()
  // Offer health is one query for all marketplaces; index it for the pulse
  // list. A marketplace never synced simply has no entry.
  const offerHealth = useOfferHealthRollup()
  const healthByMarketplace = new Map((offerHealth.data ?? []).map((h) => [h.marketplace, h]))
  const handleDateChange = (next: DashboardDateSelection) => {
    void navigate({ search: dashboardDateQuery(next) })
  }

  return (
    <AppShell title="Dashboard" fullWidth hideTitle>
      <MarketplaceRevenueOverview
        summaries={summaries.data ?? []}
        selection={selection}
        onDateChange={handleDateChange}
        rates={rates.data}
        offerHealthByMarketplace={healthByMarketplace}
        // Placeholder summaries keep the previous range on screen, but their
        // period-specific KPIs must stay hidden until this range lands.
        // Wait for rates too: otherwise non-EUR totals briefly render short.
        isLoading={summaries.isLoading || summaries.isPlaceholderData || rates.isLoading}
        error={summaries.error}
      />
    </AppShell>
  )
}

export const Route = createFileRoute("/dashboard/")({
  validateSearch: dashboardDateSearchSchema,
  component: DashboardPicker,
})
